module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousFFView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Transportation Quotation Form")])], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('div', {
    staticClass: "d-block text-center"
  }, [_c('div', [_c('b-collapse', {
    attrs: {
      "id": "collapseFFMain2"
    },
    model: {
      value: (_vm.collapseFFMainVisibleTPT),
      callback: function($$v) {
        _vm.collapseFFMainVisibleTPT = $$v
      },
      expression: "collapseFFMainVisibleTPT"
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "table-responsive tableMain mt-3"
  }, [_c('table', {
    staticClass: "table table-bordered",
    attrs: {
      "id": "tpt"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr no")]), _vm._v(" "), _c('th', [_vm._v("TPT Quotation")]), _vm._v(" "), _c('th', [_vm._v("Approval Status")]), _vm._v(" "), _c('th', [_vm._v("Action")]), _vm._v(" "), _c('th', [_vm._v("PDF")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.tptTableArryMain), function(item1, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      style: (index == 0 ? 'color:green' : 'color:red')
    }, [_c('b', [_vm._v("Quotation No. :")]), _vm._v("\n                            " + _vm._s(item1.tptQSeries) + "\n                            "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Validity Date :")]), _vm._v("\n                            " + _vm._s(_vm._f("moment")(item1.validityDate)) + "\n                            "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(item1.expireStatus == 1 ? " (Expired)" : ""))]), _vm._v(" "), (_vm.collapseFFChildVisibleTPT == false) ? _c('b-button', {
      staticClass: "gutr",
      attrs: {
        "variant": "outline-primary",
        "size": "sm"
      },
      on: {
        "click": function($event) {
          _vm.getMainTPTId(item1.tptQId, 'TPT')
        }
      }
    }, [_vm._v("Show Quote")]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('b', [_vm._v("Manager Approval :")]), _vm._v("\n                            " + _vm._s(item1.tptStatus == "0" ?
      "Pending" :
      item1.tptStatus == "1" ?
      "Approved" :
      "Rejected") + "\n                            "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Client Approval :")]), _vm._v("\n                            " + _vm._s(item1.tptClientStatus == "0" ?
      "Pending" :
      item1.tptClientStatus == "1" ?
      "Approved" :
      "Rejected") + "\n                            "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (item1.tptQuoteRejectCount != '0') ? _c('span', {
      staticClass: "error"
    }, [_vm._v("Note : Quote Rejected\n                              " + _vm._s(item1.tptQuoteRejectCount) + " Times By Client.")]) : _vm._e()]), _vm._v(" "), (
      index == '0' &&
      item1.tptClientStatus != '2' &&
      item1.tptClientStatus != '1'
    ) ? _c('td', [(
      item1.tptStatus != '1' && item1.sendHODApprove == '1'
    ) ? _c('b', [_vm._v("Sent For Approval\n                              "), _c('br')]) : (
      item1.tptStatus == '1' && item1.sentToEnquiry == '1'
    ) ? _c('b', [_vm._v("Sent to Enquiry Team\n                              "), _c('br')]) : _c('b', [_vm._v("N/A\n                              "), _c('br')])]) : _c('td', [_c('b', [_vm._v("\n                              " + _vm._s(item1.tptClientStatus == "2" && index == 0 ?
      "Client Rejected" :
      item1.tptClientStatus == "1" && index == 0 ?
      "Client Approved" :
      "N/A") + "\n                              "), _c('br')])]), _vm._v(" "), _c('td', [(item1.MainEnquiryQuotationCreated) ? _c('span', [_vm._v(_vm._s(item1.MainEnquiryQuotationCreated))]) : _vm._e(), _c('br'), _vm._v(" "), (item1.MainEnquiryQuotationUpdated) ? _c('span', [_vm._v(_vm._s(item1.MainEnquiryQuotationUpdated))]) : _vm._e(), _c('br'), _vm._v(" "), (item1.MainEnquiryQuotationTPTApprovedBy) ? _c('span', [_vm._v(_vm._s(item1.MainEnquiryQuotationTPTApprovedBy))]) : _vm._e(), _c('br'), _vm._v(" "), (
      item1.tptQuotationPdf != '' &&
      item1.tptQuotationPdf != null
    ) ? _c('md-button', {
      staticClass: "md-icon-button md-raised md-dense",
      on: {
        "click": function($event) {
          _vm.Print(item1.tptQuotationPdf)
        }
      }
    }, [_c('md-icon', [_vm._v("print")])], 1) : _c('b', [_vm._v("Pdf Not Generated")]), _vm._v(" "), (!_vm.isHidden) ? _c('div', [_c('date-picker', {
      staticStyle: {
        "margin-top": "8px"
      },
      attrs: {
        "lang": "en",
        "format": _vm.selectDateFormat,
        "id": "validityDate",
        "name": "validityDate",
        "not-before": _vm.min,
        "not-after": _vm.max
      },
      model: {
        value: (item1.validityDate),
        callback: function($$v) {
          _vm.$set(item1, "validityDate", $$v)
        },
        expression: "item1.validityDate"
      }
    }), _vm._v(" "), (!item1.validityDate) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(_vm.errorModal.validityDate))]) : _vm._e(), _vm._v(" "), _c('b-button', {
      staticClass: "smbutnWidth",
      staticStyle: {
        "margin-top": "8px"
      },
      attrs: {
        "variant": "primary",
        "size": "sm",
        "id": "updateValidityDate"
      },
      on: {
        "click": function($event) {
          _vm.updateValidityDate(
            item1.validityDate,
            item1.tptQId,
            this.mainTPTtableIdForTPT,
            'TPT',
            (_vm.quotationTill = 0),
            (_vm.prevalidityDate = item1.validityDate)
          )
        }
      }
    }, [_vm._v("Update")])], 1) : _vm._e(), _vm._v(" "), (item1.expireStatus == 1) ? _c('b-button', {
      staticClass: "smbutnWidth",
      staticStyle: {
        "margin-top": "8px"
      },
      attrs: {
        "variant": "primary",
        "size": "sm",
        "id": "QutationValidityhide"
      },
      on: {
        "click": function($event) {
          _vm.QutationValidityhide(item1.validityDate, _vm.isHidden)
        }
      }
    }, [_vm._v("Qutation Extends")]) : _vm._e(), _vm._v(" "), _c('br'), _c('span', {
      attrs: {
        "id": "QutationValidityhide_err"
      }
    })], 1)])
  }))])])])])], 1), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "id": "collapseFFChild2"
    },
    model: {
      value: (_vm.collapseFFChildVisibleTPT),
      callback: function($$v) {
        _vm.collapseFFChildVisibleTPT = $$v
      },
      expression: "collapseFFChildVisibleTPT"
    }
  }, [_c('div', [_c('div', [_c('div', [_c('div', [_c('b-card', {
    staticClass: "gutr"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', {
    staticClass: "pull-left"
  }, [_vm._v("Quotation Validity Date *")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "disabled": _vm.mainTPTtableIdForTPT ? true : false,
      "formatter": _vm.capitalizeAll,
      "type": "date",
      "placeholder": "Enter Billing Start Date",
      "min": _vm.calculateMinDate(),
      "max": _vm.calculateMaxDate(),
      "not-before": new Date()
    },
    model: {
      value: (_vm.tptModal.validityDate),
      callback: function($$v) {
        _vm.$set(_vm.tptModal, "validityDate", $$v)
      },
      expression: "tptModal.validityDate"
    }
  }), _vm._v(" "), (!_vm.tptModal.validityDate) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errortptModal.validityDate))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', {
    staticClass: "pull-left",
    attrs: {
      "for": "quoRate"
    }
  }, [_vm._v("Quotation Remarks")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "quoRate",
      "name": "quoRate"
    },
    model: {
      value: (_vm.tptModal.quotation_remark),
      callback: function($$v) {
        _vm.$set(_vm.tptModal, "quotation_remark", $$v)
      },
      expression: "tptModal.quotation_remark"
    }
  })], 1), _vm._v(" "), (
    _vm.tptModal.tptQId != '' &&
    _vm.tptModal.sendHODApprove == '1' &&
    this.$sessionsStorage.get('userLevel') == '1'
  ) ? _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', {
    staticClass: "w-100 text-left",
    attrs: {
      "for": "transportType"
    }
  }, [_vm._v("Manager Approval")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.tptModal.tptClientStatus == '1' ? true : false,
      "list": _vm.statusList,
      "option-value": "statusV",
      "option-text": "statusT",
      "placeholder": "Select Status"
    },
    model: {
      value: (_vm.tptModal.tptStatus),
      callback: function($$v) {
        _vm.$set(_vm.tptModal, "tptStatus", $$v)
      },
      expression: "tptModal.tptStatus"
    }
  })], 1) : _vm._e(), _vm._v(" "), (
    _vm.tptModal.tptQId != '' && _vm.tptModal.sendHODApprove == '1'
  ) ? _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', {
    staticClass: "pull-left",
    attrs: {
      "for": "quoRate"
    }
  }, [_vm._v("Remarks if Any")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "quoRate",
      "name": "quoRate"
    },
    model: {
      value: (_vm.tptModal.remark),
      callback: function($$v) {
        _vm.$set(_vm.tptModal, "remark", $$v)
      },
      expression: "tptModal.remark"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mt-2"
  }, [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [(_vm.tptTableArry.length > 0) ? _c('div', {
    staticStyle: {
      "text-align": "left"
    }
  }, [(
    _vm.tptModal.tptQId != '' &&
    _vm.tptModal.sendHODApprove == '1'
  ) ? _c('b-button', {
    staticClass: "smbutnWidth",
    attrs: {
      "variant": "primary",
      "size": "sm",
      "id": "addButtonLoaderAdd"
    },
    on: {
      "click": function($event) {
        _vm.addGenerateQuotation('5')
      }
    }
  }, [_vm._v(_vm._s(_vm.tptModal.tptQId == "" ? "Add" : "Update"))]) : _vm._e(), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderAdd"
    }
  }), _vm._v(" "), _c('b-button-group', [_c('b-button', {
    staticClass: "pull-left",
    attrs: {
      "size": "sm",
      "variant": "outline-dark"
    },
    on: {
      "click": function($event) {
        _vm.visibleMTPT = !_vm.visibleMTPT
      }
    }
  }, [(_vm.visibleMTPT == true) ? _c('span', [_vm._v("Close")]) : _c('span', [_vm._v("Add More Particulars")])])], 1)], 1) : _vm._e()]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-navbar-nav', {
    staticClass: "ml-auto pull-right"
  }, [(_vm.tptTableArry.length > 0) ? _c('div', [_c('b-button-group', [(
    _vm.tptModal.tptQId != '' &&
    _vm.tptModal.tptStatus != '1' &&
    _vm.tptModal.tptClientStatus != '2' &&
    _vm.tptModal.sendHODApprove != '1'
  ) ? _c('b-button', {
    attrs: {
      "variant": "outline-dark",
      "size": "sm"
    },
    on: {
      "click": _vm.openPop
    }
  }, [_vm._v("Send For Approval\n                                    "), _c('md-icon', {
    attrs: {
      "icon": "envelope"
    }
  }, [_vm._v("email")])], 1) : _vm._e()], 1)], 1) : _vm._e()])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('b-collapse', {
    staticClass: "mt-2",
    attrs: {
      "id": "collapseMiddle"
    },
    model: {
      value: (_vm.visibleMTPT),
      callback: function($$v) {
        _vm.visibleMTPT = $$v
      },
      expression: "visibleMTPT"
    }
  }, [_c('b-card', [_c('b-row', [_c('b-col', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "md": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "distance"
    }
  }, [_vm._v("Distance (Km)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "distance",
      "name": "distance",
      "type": "number"
    },
    model: {
      value: (_vm.tptTableModal.distance),
      callback: function($$v) {
        _vm.$set(_vm.tptTableModal, "distance", $$v)
      },
      expression: "tptTableModal.distance"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "md": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "dieselRate"
    }
  }, [_vm._v("Diesel Allocated (Ltrs)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "dieselRate",
      "name": "dieselRate",
      "type": "number"
    },
    model: {
      value: (_vm.tptTableModal.dieselAllocated),
      callback: function($$v) {
        _vm.$set(_vm.tptTableModal, "dieselAllocated", $$v)
      },
      expression: "tptTableModal.dieselAllocated"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "md": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "dieselRate"
    }
  }, [_vm._v("Diesel Rate (INR)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "dieselRate",
      "name": "dieselRate",
      "type": "number"
    },
    model: {
      value: (_vm.tptTableModal.dieselRate),
      callback: function($$v) {
        _vm.$set(_vm.tptTableModal, "dieselRate", $$v)
      },
      expression: "tptTableModal.dieselRate"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "md": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "mileage"
    }
  }, [_vm._v("Mileage")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "mileage",
      "name": "mileage",
      "type": "number"
    },
    model: {
      value: (_vm.tptTableModal.mileage),
      callback: function($$v) {
        _vm.$set(_vm.tptTableModal, "mileage", $$v)
      },
      expression: "tptTableModal.mileage"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "md": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "toll"
    }
  }, [_vm._v("Toll (INR)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "toll",
      "name": "toll",
      "type": "number"
    },
    model: {
      value: (_vm.tptTableModal.toll),
      callback: function($$v) {
        _vm.$set(_vm.tptTableModal, "toll", $$v)
      },
      expression: "tptTableModal.toll"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "md": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "margin"
    }
  }, [_vm._v("Advance Cash (INR)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "margin",
      "name": "margin",
      "type": "number"
    },
    model: {
      value: (_vm.tptTableModal.advanceCash),
      callback: function($$v) {
        _vm.$set(_vm.tptTableModal, "advanceCash", $$v)
      },
      expression: "tptTableModal.advanceCash"
    }
  })], 1)], 1), _vm._v(" "), (_vm.tptModal.shipmentType == '1') ? _c('b-row', [_c('b-col', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "md": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "transportType"
    }
  }, [_vm._v("Container Type *")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.containerTypeList,
      "option-value": "containerTypeId",
      "option-text": "containerType",
      "placeholder": "Select Type"
    },
    model: {
      value: (_vm.tptTableModal.containerTypeId),
      callback: function($$v) {
        _vm.$set(_vm.tptTableModal, "containerTypeId", $$v)
      },
      expression: "tptTableModal.containerTypeId"
    }
  }), _vm._v(" "), (!_vm.tptTableModal.containerTypeId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.blankConTypeError))]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('b-row', [(_vm.tptTableModal.tptTableId == '') ? _c('b-col', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "md": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "transportType"
    }
  }, [_vm._v("Particulars *")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllLedgerList'],
      "option-value": "ledgerId",
      "option-text": "ledger",
      "placeholder": "Select Particular"
    },
    on: {
      "input": _vm.getPartiName
    },
    model: {
      value: (_vm.tptTableModal.ledgerId),
      callback: function($$v) {
        _vm.$set(_vm.tptTableModal, "ledgerId", $$v)
      },
      expression: "tptTableModal.ledgerId"
    }
  }), _vm._v(" "), (!_vm.tptTableModal.ledgerId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errortptTableModal.ledgerId))]) : _vm._e()], 1) : _c('b-col', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "md": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "transportType"
    }
  }, [_vm._v("Particulars")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": "",
      "list": _vm.ledgerData,
      "option-value": "ledger",
      "option-text": "ledger",
      "placeholder": "Select Particulars"
    },
    model: {
      value: (_vm.tptTableModal.otherCharge),
      callback: function($$v) {
        _vm.$set(_vm.tptTableModal, "otherCharge", $$v)
      },
      expression: "tptTableModal.otherCharge"
    }
  })], 1), _vm._v(" "), (_vm.particularStatus == '0') ? _c('b-col', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "md": "2"
    }
  }, [_c('label', {
    attrs: {
      "for": "sellingRate"
    }
  }, [_vm._v("Buy In Rate *")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "sellingRate",
      "name": "sellingRate",
      "type": "number"
    },
    model: {
      value: (_vm.tptTableModal.byInPrice),
      callback: function($$v) {
        _vm.$set(_vm.tptTableModal, "byInPrice", $$v)
      },
      expression: "tptTableModal.byInPrice"
    }
  }), _vm._v(" "), (!_vm.tptTableModal.byInPrice) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.blankbuyinError))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.particularStatus == '0') ? _c('b-col', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "md": "2"
    }
  }, [_c('label', {
    attrs: {
      "for": "buyingRate"
    }
  }, [_vm._v("Selling Rate *")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "buyingRate",
      "name": "buyingRate",
      "type": "number"
    },
    model: {
      value: (_vm.tptTableModal.qRate),
      callback: function($$v) {
        _vm.$set(_vm.tptTableModal, "qRate", $$v)
      },
      expression: "tptTableModal.qRate"
    }
  }), _vm._v(" "), (!_vm.tptTableModal.qRate) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.blankSellingError))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.particularStatus == '0') ? _c('b-col', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "md": "2"
    }
  }, [_c('label', {
    attrs: {
      "for": "transportType"
    }
  }, [_vm._v("Currency *")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.currencyList,
      "option-value": "currencyV",
      "option-text": "currencyT",
      "placeholder": "Select"
    },
    model: {
      value: (_vm.tptTableModal.currency),
      callback: function($$v) {
        _vm.$set(_vm.tptTableModal, "currency", $$v)
      },
      expression: "tptTableModal.currency"
    }
  }), _vm._v(" "), (!_vm.tptTableModal.currency) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.blankcurrencyError))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.particularStatus == '0') ? _c('b-col', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "md": "2"
    }
  }, [_c('label', {
    attrs: {
      "for": "transportType"
    }
  }, [_vm._v("Units *")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.unitList,
      "option-value": "unitId",
      "option-text": "unitName",
      "placeholder": "Select"
    },
    model: {
      value: (_vm.tptTableModal.unit),
      callback: function($$v) {
        _vm.$set(_vm.tptTableModal, "unit", $$v)
      },
      expression: "tptTableModal.unit"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-checkbox', {
    staticClass: "pull-left",
    attrs: {
      "id": "checkbox-1",
      "name": "checkbox-1",
      "value": "1",
      "unchecked-value": "0"
    },
    model: {
      value: (_vm.particularStatus),
      callback: function($$v) {
        _vm.particularStatus = $$v
      },
      expression: "particularStatus"
    }
  }, [_vm._v("Charges As Per Receipt")])], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "md": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "transportType"
    }
  }, [_vm._v("Terms")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.termList,
      "option-value": "tV",
      "option-text": "tT",
      "placeholder": "Select"
    },
    model: {
      value: (_vm.tptTableModal.terms),
      callback: function($$v) {
        _vm.$set(_vm.tptTableModal, "terms", $$v)
      },
      expression: "tptTableModal.terms"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "md": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "freeDays"
    }
  }, [_vm._v("Free Days")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "freeDays",
      "name": "freeDays",
      "type": "number"
    },
    model: {
      value: (_vm.tptTableModal.freeDays),
      callback: function($$v) {
        _vm.$set(_vm.tptTableModal, "freeDays", $$v)
      },
      expression: "tptTableModal.freeDays"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "md": "12"
    }
  }, [_c('label', {
    attrs: {
      "for": "sellingRate"
    }
  }, [_vm._v("Special Remarks")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "sellingRate",
      "name": "sellingRate"
    },
    model: {
      value: (_vm.tptTableModal.line_wise_remark),
      callback: function($$v) {
        _vm.$set(_vm.tptTableModal, "line_wise_remark", $$v)
      },
      expression: "tptTableModal.line_wise_remark"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mt-4"
  }, [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-button', {
    staticClass: "smbutnWidth",
    attrs: {
      "size": "sm",
      "variant": "primary",
      "id": "addButtonLoaderOth",
      "disabled": _vm.$sessionsStorage.get('designation') == 'Admin' &&
        _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh' ?
        false :
        _vm.buttonDisable
    },
    on: {
      "click": function($event) {
        _vm.addGenerateQuotation('1')
      }
    }
  }, [_vm._v(_vm._s(_vm.tptTableModal.tptTableId == "" ? "Add" : "Update"))]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderOth"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [(_vm.tptTableModal.MainEnquiryQuotationCreated) ? _c('span', {
    staticClass: "error pull-right"
  }, [_c('b', [_vm._v(" " + _vm._s(_vm.tptTableModal.MainEnquiryQuotationCreated))])]) : _vm._e()]), _vm._v(" "), _c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [(_vm.tptTableModal.MainEnquiryQuotationUpdated) ? _c('span', {
    staticClass: "error pull-right"
  }, [_c('b', [_vm._v(" " + _vm._s(_vm.tptTableModal.MainEnquiryQuotationUpdated))])]) : _vm._e()])], 1)], 1)], 1)], 1)]), _vm._v(" "), (_vm.tptTableArry.length > 0) ? _c('div', {
    staticClass: "box-body"
  }, [_c('div', [_c('div', {
    staticClass: "box-header"
  }), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain"
  }, [_c('table', {
    staticClass: "table table-bordered",
    attrs: {
      "id": "tpt"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr no")]), _vm._v(" "), (_vm.tptModal.shipmentType == '1') ? _c('th', [_vm._v("\n                                Container Type\n                              ")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("Particulars")]), _vm._v(" "), _c('th', [_vm._v("Buy In Rate")]), _vm._v(" "), _c('th', [_vm._v("Selling Rate")]), _vm._v(" "), _c('th', [_vm._v("Unit")]), _vm._v(" "), _c('th', [_vm._v("Special Remarks")]), _vm._v(" "), _c('th', [_vm._v("Edit")]), _vm._v(" "), _c('th', [_vm._v("Delete")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.tptTableArry), function(item1, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), (_vm.tptModal.shipmentType == '1') ? _c('td', [_vm._v("\n                                " + _vm._s(item1.containerType) + "\n                              ")]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.otherCharge))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.byInPrice) + " " + _vm._s(item1.currency))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.qRate) + " " + _vm._s(item1.currency))]), _vm._v(" "), _c('td', [_vm._v("\n                                " + _vm._s(item1.unitName ? item1.unitName : "NA") + "\n                              ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.line_wise_remark))]), _vm._v(" "), _c('td', [_c('md-button', {
      staticClass: "md-icon-button md-raised md-dense",
      on: {
        "click": function($event) {
          _vm.editTPT(item1)
        }
      }
    }, [_c('md-icon', [_vm._v("edit")])], 1)], 1), _vm._v(" "), _c('td', [_c('md-button', {
      staticClass: "md-icon-button md-raised md-dense",
      on: {
        "click": function($event) {
          _vm.deleteTPT(item1)
        }
      }
    }, [_c('md-icon', [_vm._v("delete")])], 1)], 1)])
  }))])])])]) : _vm._e()])])])], 1)])], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "popMail",
    attrs: {
      "md-title": _vm.confirm.title,
      "md-content-html": _vm.confirm.contentHtml,
      "md-ok-text": _vm.confirm.ok,
      "md-cancel-text": _vm.confirm.cancel
    },
    on: {
      "close": _vm.sendMail
    }
  }), _vm._v(" "), _c('md-snackbar', {
    ref: "snackbar",
    attrs: {
      "md-position": _vm.vertical + ' ' + _vm.horizontal,
      "md-duration": _vm.duration
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.snackbarData))])]), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "popMailAfter",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b0f2575","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/allModuleForm/mainEnqQuotation.vue
// module id = 2534
// module chunks = 0